import RevolverSettings from "model/revolver-settings";
import gameState from "slotworks/model/game-state";
import soundManager from "slotworks/sound/sound-manager";

export function StartBaseMusic(update: boolean = false) {
    if (!gameState.getCurrentGame().inFreespinsGame) {
        if (update) RevolverSettings.lastWinTime = Date.now();

        if (RevolverSettings.winCount == 0 || Date.now() - RevolverSettings.lastWinTime > 10000) {
            soundManager.customEvent("base_music");
            RevolverSettings.winCount = 0;
        } else {
            if (RevolverSettings.winCount == 1) {
                soundManager.customEvent("base_music_win");
            } else {
                soundManager.customEvent("base_music_win2");
            }
        }
    }
}

export function StartBaseMusicSoft(update: boolean = false) {
    if (!gameState.getCurrentGame().inFreespinsGame) {
        if (update) RevolverSettings.lastWinTime = Date.now();

        if (RevolverSettings.winCount == 0 || Date.now() - RevolverSettings.lastWinTime > 10000) {
            soundManager.customEvent("base_music_silent");
            RevolverSettings.winCount = 0;
        } else {
            if (RevolverSettings.winCount == 1) {
                soundManager.customEvent("base_music_win_silent");
            } else {
                soundManager.customEvent("base_music_win2_silent");
            }
        }
    }
}

export function StartBaseMusicSofter() {
    if (!gameState.getCurrentGame().inFreespinsGame) {
        if (RevolverSettings.winCount == 0) {
            soundManager.customEvent("base_music_silent");
        } else if (RevolverSettings.winCount == 1) {
            soundManager.customEvent("base_music_win_soft");
        } else {
            soundManager.customEvent("base_music_win2_soft");
        }
    }
}
